import Notice from "../components/Notice.js";

const News=()=>{
    return <Notice isHidden />;

}

export default News;

